import React, { useEffect, useState, useRef } from 'react';
import { Container, Row, Col } from 'react-bootstrap';

function TeamMembers({ teamMembers }) {
  const itemRefs = useRef([]);
  const [visibleItems, setVisibleItems] = useState([]);

  useEffect(() => {
    itemRefs.current = itemRefs.current.slice(0, teamMembers?.length);

    if (typeof window === 'undefined' || !('IntersectionObserver' in window)) {
      setVisibleItems(teamMembers?.map((_, i) => i));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const index = Number(entry.target.getAttribute('data-index'));
          if (entry.isIntersecting) {
            setVisibleItems((prev) => (prev.includes(index) ? prev : [...prev, index]));
            observer.unobserve(entry.target);
          }
        });
      },
      { root: null, rootMargin: '0px 0px -10% 0px', threshold: 0.15 }
    );

    itemRefs.current.forEach((el) => el && observer.observe(el));

    return () => observer.disconnect();
  }, [teamMembers.length]);

  return (
    <section className="team-member-section pt-5" id="management">
      <Container>
        <h3 className="mb-5">Management Team</h3>
        <Row>
          {teamMembers?.length === 0 && <p>Loading team members...</p>}
          {teamMembers?.map((member, index) => (
            <Col
              key={member.id}
              md={12}
              data-index={index}
              ref={(el) => (itemRefs.current[index] = el)}
              className={`animate ${visibleItems.includes(index) ? 'slide-up' : ''}`}
              style={{ animationDelay: `${index * 0.2}s` }}
            >
              <div className="team-item">
                <Row>
                  <Col md={3}>
                    <img className="avatar" src={member.imageUrl} alt="avatar" />
                    <h4 className="name">{member.name}</h4>
                    <h5 className="position">{member.position}</h5>
                  </Col>
                  <Col md={9}>
                    <p>{member.description}</p>
                  </Col>
                </Row>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
}

export default TeamMembers;
